import React, { useState, useEffect } from "react";
import { Button} from 'reactstrap';
import Draggable from "react-draggable";
const riskData = [
    ['Low', 'Low', 'Medium', 'High'],
    ['Low', 'Medium', 'High', 'High'],
    ['Medium', 'Medium', 'High', 'High'],
];

const likelihoodLabels = ['Unlikely', 'Possible', 'Probable', 'Certain'];
const impactLabels = ['Low', 'Medium', 'High'];

const DraggableDialog = ({ hideRiskMatrixPopup }) => {

    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [defaultPosition, setDefaultPosition] = useState(null);

    useEffect(() => {
        const updateDimensions = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
            setDefaultPosition({
                x: (window.innerWidth - 600) / 2, // Center horizontally
                y: (window.innerHeight - 900) / 2, // Center vertically
            });
        };

        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    if (!defaultPosition) {
        return null; // Avoid rendering until default position is calculated
    }
    return (
        <Draggable bounds={{
            left: 0,
            top: 0,
            right: windowSize.width - 600, // Subtract dialog width
            bottom: windowSize.height - 900, // Subtract dialog height
        }}
            defaultPosition={defaultPosition} // Center by default
        >
            <div
                style={{
                    width: "600px",
                    height: "400px",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "16px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    position: "absolute", // Ensure position is set to allow zIndex to work
                    zIndex: 1000, // Set the z-index
                }}
            >
                <div
                    style={{
                        cursor: "move",
                        padding: "6px",
                        fontWeight:"bold",
                        borderBottom: "1px solid #ccc",
                        fontSize:"20px"
                    }}
                >
                    Risk Matrix
                    {/*<Button className="float-end" style={{*/}
                    {/*    fontWeight: "400",*/}
                    {/*    marginRight: "10px",*/}
                    {/*    cursor: "pointer",*/}
                    {/*    marginTop: "-10px",*/}
                    {/*    backgroundColor: "white",*/}
                    {/*    color: "black"*/}
                    {/*}} onClick={hideRiskMatrixPopup}>X</Button>*/}
                </div>  
                <div style={{ padding: "16px" }}>

                    <div>
                        <table style={{ borderCollapse: 'collapse', textAlign: 'center' }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Likelihood</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className="rotated-label">Impact</th>
                                    <td>
                                        <table style={{ borderCollapse: 'collapse', textAlign: 'center' }}>
                                            <thead>
                                                <tr>
                                                    <th rowSpan="2"></th>
                                                    <th colSpan={likelihoodLabels.length}></th>
                                                </tr>
                                                <tr>
                                                    {likelihoodLabels.map((label, index) => (
                                                        <th key={index} style={{ padding: '10px', border: "1px solid black" }}>{label}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {riskData.map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        <td style={{ padding: '10px', border: "1px solid black", fontWeight: "bold" }}>{impactLabels[rowIndex]}</td>
                                                        {row.map((risk, colIndex) => (
                                                            <td
                                                                key={colIndex}
                                                                style={{
                                                                    backgroundColor:
                                                                        risk === 'Low' ? 'rgb(0, 188, 18)' :
                                                                            risk === 'Medium' ? 'rgb(255, 134, 3)' :
                                                                                risk === 'High' ? 'rgb(224, 0, 0)' : 'transparent',
                                                                    color: 'white',
                                                                    padding: '5px',
                                                                    border: "1px solid black"
                                                                }}
                                                            >
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </td>
                                    <td>
                                        <div style={{ marginTop: '20px', textAlign: 'left', marginLeft: '20px', fontWeight: "bold" }}>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                <div style={{ width: '20px', height: '20px', backgroundColor: 'rgb(0, 188, 18)', marginRight: '10px', borderRadius: "50%" }}></div>
                                                Low
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                <div style={{ width: '20px', height: '20px', backgroundColor: 'rgb(255, 134, 3)', marginRight: '10px', borderRadius: "50%" }}></div>
                                                Medium
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                <div style={{ width: '20px', height: '20px', backgroundColor: 'rgb(224, 0, 0)', marginRight: '10px', borderRadius: "50%" }}></div>
                                                High
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={{ color: "black", fontSize: "16px",marginTop:"10px",fontWeight:"bold" }} >
                        For example: probable likelihood + medium impact = <span style={{ color: "rgb(224, 0, 0)" }}>High Risk</span>.
                    </div>
                    <hr/>
                    <Button  className="btn btn-primary btn-sm float-end"  onClick={hideRiskMatrixPopup}>Close</Button>
                </div>
            </div>
        </Draggable>
    );
};
export default DraggableDialog;